import React, { type PropsWithChildren, useEffect, useMemo, useState } from 'react';
import Loader from '../../ui/loader/Loader';
import AdaptiveProvider from '../adaptive/AdaptiveProvider';
import ToursProvider from '../../features/tours/contexts/ToursProvider';
import { useAuth } from '../auth/AuthContext';
import { useAppInfo } from '../app-info/AppInfoContext';

const MIN_BOOTSTRAP_LOADER_MS = 350;

const ContextBuffer: React.FC<PropsWithChildren> = ({ children }) => {
    const { tokenState} = useAuth();
    const { authenticationState } = useAppInfo();
    const [showLoader, setShowLoader] = useState(true);

    const isLoadingUser = useMemo(() => false, []);
    const isLoadingToken = useMemo(() => tokenState === undefined, [tokenState]);
    const isLoadingAppInfo = useMemo(() => authenticationState === undefined, [authenticationState]);
    const isLoading = useMemo(() => isLoadingUser || isLoadingAppInfo || isLoadingToken, [isLoadingAppInfo, isLoadingToken, isLoadingUser]);

    useEffect(() => {
        if (isLoading) {
            setShowLoader(true);
            return;
        }

        const timeout = window.setTimeout(() => {
            setShowLoader(false);
        }, MIN_BOOTSTRAP_LOADER_MS);

        return () => window.clearTimeout(timeout);
    }, [isLoading]);

    const shouldShowLoader = isLoading || showLoader;

    return <>
        {shouldShowLoader && <Loader isVisible isGlobal isInline={false} />}

        {!shouldShowLoader && (
            <AdaptiveProvider>
                <ToursProvider>
                    {children}
                </ToursProvider>
            </AdaptiveProvider>
        )}
    </>;
};

export default ContextBuffer;